<lc-dropdown displayPath="displayTime" label="Time" valuePath="offsetInMinutes" [formControl]="formControl" [options]="options" (selectionChanged)="onSelectionChanged($event)" />

